import { Link } from "react-router-dom";

const footerCategories = [
  "百合同志",
  "耽美同人",
  "纯爱治愈",
  "热血冒险",
  "奇幻仙侠",
  "校园青春",
];

const footerLinks = [
  { to: "/category", label: "同人志分类" },
  { to: "/popular", label: "热门榜单" },
  { to: "/gems", label: "冷门佳作" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                同人志指南
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              一站式的同人志分类导航、CP 配对推荐与作品盘点平台，助你快速找到心仪的同人作品，也愿你发现被埋没的宝藏。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-accent-300">
              快速导航
            </h4>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-secondary-300 transition-colors hover:text-background-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-accent-300">
              热门分类
            </h4>
            <ul className="mt-4 space-y-3">
              {footerCategories.map((c) => (
                <li key={c}>
                  <Link to="/category" className="text-sm text-secondary-300 transition-colors hover:text-background-50">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-accent-300">
              联系我们
            </h4>
            <p className="mt-4 text-sm text-secondary-300">
              有任何建议、投稿或纠错反馈，欢迎来信告诉我们。
            </p>
            <a
              href="mailto:hello@doujinshi-guide.example"
              className="mt-3 inline-flex items-center gap-2 text-sm text-background-50 hover:text-accent-300"
            >
              <i className="ri-mail-line"></i>
              hello@doujinshi-guide.example
            </a>
            <p className="mt-3 text-sm text-secondary-400">
              我们珍视每一份热爱，期待与你共建同人阅读社区。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-secondary-800 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-400">
            © {new Date().getFullYear()} 同人志指南 · 仅供内容导航与交流参考
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-background-50" rel="nofollow">隐私说明</a>
            <a href="#" className="hover:text-background-50" rel="nofollow">投稿指南</a>
          </div>
        </div>
      </div>
    </footer>
  );
}